import { Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { updateDevice } from '../Async/UpdateDeviceAsync';
import { ButtonMode } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { StyledDialogContent } from '../Components/Dialog/StyledDialogContent';
import { DeviceIcon } from '../Components/Icons';
import { LayoutCentral } from '../Components/Layout/LayoutCentral';
import { Nullable } from '../Shared/Types';
import { MaskedTextField } from '../Components/MaskedTextField';
import styles from './UpdateDevice.module.scss';


interface UpdateDeviceProps {
    authoringSystem: string;
    authoringSystemForeignKey: string;
    prodaClientID: string;
    applicationName: string;
    deviceUpdated: () => void;
}

interface UpdateDeviceDialogProps extends UpdateDeviceProps {
    onClose: () => void;
}


function useDeviceDetails(props: UpdateDeviceDialogProps) {

    const authSystem = props.authoringSystem;
    const authSystemFk = props.authoringSystemForeignKey;

    const [prodaClientID, setprodaClientID] = useState(props.prodaClientID);
    
    const [applicationName, setApplicationName] = useState(props.applicationName);
    function updateProdaClientID(prodaClientID: string) {
        setprodaClientID(prodaClientID);
    }
    function updateApplicationName(applicationName: string) {
        setApplicationName(applicationName);
    }
    

    async function runUpdateDevice() {

        try {

            await updateDevice(authSystem, authSystemFk, prodaClientID, applicationName);

            props.deviceUpdated();

        } catch (e) {
            console.log(e);
        }
    }

    return {
        authSystem,
        authSystemFk,
        prodaClientID,
        applicationName,
        runUpdateDevice,
        updateProdaClientID,
        updateApplicationName
    };
}


function UpdateDeviceDialog(props: UpdateDeviceDialogProps): JSX.Element {

    const deviceDetails = useDeviceDetails(props);

    const [authSystem, setAuthSystem] = useState<Nullable<string>>(null);
    const [authSystemFk, setAuthSystemFk] = useState<Nullable<string>>(null);
    const [prodaClientID, setProdaClientID] = useState<Nullable<string>>(null);
    const [applicationName, setApplicationName] = useState<Nullable<string>>(null);

    async function updateDetails() {
        setAuthSystem(deviceDetails.authSystem);
        setAuthSystemFk(deviceDetails.authSystemFk);
        setProdaClientID(deviceDetails.prodaClientID);
        setApplicationName(deviceDetails.applicationName);
    }

    useEffect(() => {
        updateDetails();
    }, []);


    return (
        <StyledDialog
            size='xs'
            open
            title='Update Device'
            closeFunction={props.onClose}
            actions={[
                <StyledDialogButton
                    title='Update'
                    key='update-device-dialog-props'
                    onClick={deviceDetails.runUpdateDevice}
                    mode={ButtonMode.border}
                    width={112}
                    testId='updateDevice-update-dialog'
                >
                    Update
                </StyledDialogButton>,
                <StyledDialogButton
                    title='Close'
                    key='close-device-dialog-props'
                    onClick={props.onClose}
                    mode={ButtonMode.border}
                    width={112}
                    testId='updateDevice-close-dialog'
                >
                    Close
                </StyledDialogButton>
            ]}
            contentComponent={
                <StyledDialogContent>
                    <LayoutCentral>
                        <div>
                            <MaskedTextField
                                value={deviceDetails.authSystem}
                                disabled
                                label='Auth system'
                                testId='authSystem' />

                            <MaskedTextField
                                value={deviceDetails.authSystemFk}
                                disabled
                                label='Auth system key'
                                testId='authSystemKey' />

                            <MaskedTextField
                                value={deviceDetails.prodaClientID}
                                label='PRODA Client ID'
                                testId='PRODAClientID'
                                onChange={value => deviceDetails.updateProdaClientID(value)} />

                            <MaskedTextField
                                value={deviceDetails.applicationName}
                                label='Application name'
                                testId='applicationname'
                                onChange={value => deviceDetails.updateApplicationName(value)} />
                        </div>
                    </LayoutCentral>
                </StyledDialogContent>
            }
        />

    );
}

export function UpdateDevice(props: UpdateDeviceProps): JSX.Element {
    const [showDialog, setShowDialog] = useState<boolean>(false);

    function iconClick(e: React.MouseEvent<HTMLElement>) {
        e.stopPropagation();
        setShowDialog(true);
    }

    function dialogClose() {
        setShowDialog(false);
    }

    return (
        <>
            <Tooltip title='Update device'>
                <span>
                    <DeviceIcon size='40' className={styles.icon} onClick={iconClick} />
                </span>
            </Tooltip>
            {showDialog && (
                <UpdateDeviceDialog
                    authoringSystem={props.authoringSystem}
                    onClose={dialogClose}
                    authoringSystemForeignKey={props.authoringSystemForeignKey}
                    prodaClientID={props.prodaClientID}
                    applicationName={props.applicationName}
                    deviceUpdated={props.deviceUpdated}
                />
            )}
        </>
    );
}
